/**
 * "SEM ETIQUETA" NA CAMPANHA DE FLY — pedido do Ruan em 28/09/2026 (migration 0302).
 *
 * Nao e' uma etiqueta cadastrada: e' uma opcao do combo da campanha que escolhe quem NAO tem
 * nenhuma etiqueta VISIVEL (as ocultas, como as de vendedora, nao contam — a mesma regra do
 * "sem etiqueta" da aba Contatos do dia). Serve pra completar o teto diario sem ele ter que marcar
 * os contatos um a um.
 *
 * Viaja em `etiqueta_ids` como o id 0 — na tela, na rota e na coluna `campanhas_fly.etiqueta_ids`
 * —, porque nenhuma etiqueta real tem id 0 (serial comeca em 1). Assim a campanha continua sendo
 * "uma lista de etiquetas" pra todo mundo que ja le essa lista, e a uniao com etiquetas reais
 * ("CONSUMIDOR + Sem etiqueta") sai de graca.
 *
 * ⚠️ Nao virar etiqueta cadastrada: marcada em 855 contatos ela os contaria como etiquetados na
 * aba Contatos do dia, e o "X sem etiqueta" — a fila de trabalho de classificar — cairia a zero
 * sem ninguem ter classificado nada.
 */
export const SEM_ETIQUETA_ID = 0;

export const SEM_ETIQUETA_NOME = 'SEM ETIQUETA';
